import Echo from "@ably/laravel-echo";
import config from "@/config";
import {cookies} from "@/util";
import * as Ably from "ably";
import {Peer as PeerNode} from "peerjs";
import NotificationSound from "@/assets/notification.wav";

const DefaultPeerOptions = {
    config: {
        iceServers: [
            {
                urls: 'stun:159.223.246.216:5349',
                username: 'admin',
                credential: 'dappturn555',
            },
            {
                urls: 'turn:159.223.246.216:5349',
                username: 'admin',
                credential: 'dappturn555',
            },
            { urls: "stun:stun.l.google.com:19302" },
            { urls: "stun:stun.l.google.com:5349" },
            { urls: "stun:stun1.l.google.com:3478" },
            { urls: "stun:stun1.l.google.com:5349" },
            { urls: "stun:stun2.l.google.com:19302" },
            { urls: "stun:stun2.l.google.com:5349" },
            { urls: "stun:stun3.l.google.com:3478" },
            { urls: "stun:stun3.l.google.com:5349" },
            { urls: "stun:stun4.l.google.com:19302" },
            { urls: "stun:stun4.l.google.com:5349" },
        ],
    },
};

const Peer = () => {
    var Instance = {
        DefaultCallOptions: {
            'sdpTransform': (str) => {
                return str.replace("a=fmtp:111 minptime=10;useinbandfec=1","a=fmtp:111 ptime=5;useinbandfec=1;stereo=1;maxplaybackrate=48000;maxaveragebitrat=128000;sprop-stereo=1");
            },
        },

        currentLocalPeer: null,
        localPeers: {},

        connection: null,

        listeners: {
            open: null,
            data: null,
            connection: null,
            handshake: null,
            confirm_handshake: null,
            refuse_handshake: null,
            close: null,
            state: null,
        },

        currentState: 'ready', // 'connecting', 'handshake', 'connected'
        initiatedByMe: false,

        onCall: (cb) => {
            Instance.currentLocalPeer.on('call', cb);
        },

        close: (userId) => {
            Instance.send({action: 'close', userId: userId ? userId : Instance.connection?.peer});

            if (Instance.connection) {
                Instance.connection.close();
            }

            Instance.initiatedByMe = false;
            Instance.connection = null;
            Instance.state('ready');
        },

        state: (value) => {
            console.log('Peer.state', Instance.currentState, ' --> ', value);
            console.log('Peer.listeners', Instance.listeners);

            const previousStateHandshake = Instance.currentState === 'handshake';
            Instance.currentState = value;
            if (Instance.currentState === 'handshake') {
                try {
                    if (document.querySelector('#call-audio')) {
                        document.querySelector('#call-audio').play();
                    }
                } catch (e) {
                    //
                }
            } else if (previousStateHandshake) {
                try {
                    if (document.querySelector('#call-audio')) {
                        document.querySelector('#call-audio').stop();
                    }
                } catch (e) {
                    //
                }
            }


            if (Instance.listeners['state']) {
                Instance.listeners['state'](value);
            }
        },

        call: (stream, cb) => {
            if (!Instance.connection) {
                return;
            }

            const call = Instance.currentLocalPeer.call(Instance.connection.peer, stream, {
                ...DefaultPeerOptions, ...Instance.DefaultCallOptions,
            });
            call.on('stream', cb);
        },

        /**
         * @private
         */
        onConnect: (conn) => {
            Instance.connection = conn;

            Instance.connection.on('open', () => {
                if (Instance.listeners['open']) {
                    Instance.listeners['open'](conn.peer);
                }
            });

            Instance.connection.on('data', message => {
                if (message.action) {
                    switch (message.action) {
                        case 'connect':
                            Instance.state('handshake');

                            if (Instance.listeners['handshake']) {
                                Instance.listeners['handshake'](conn.peer, message.userId);
                            }
                            break;
                        case 'confirm_handshake':
                            Instance.state('connected');

                            if (Instance.listeners['confirm_handshake']) {
                                Instance.listeners['confirm_handshake'](conn.peer, message.userId);
                            }
                            break;
                        case 'refuse_handshake':
                            Instance.state('ready');

                            if (Instance.listeners['refuse_handshake']) {
                                Instance.listeners['refuse_handshake'](conn.peer, message.userId);
                            }
                            break;
                        case 'close':
                            Instance.state('ready');

                            if (Instance.listeners['close']) {
                                Instance.listeners['close'](conn.peer, message.userId);
                            }

                            Instance.close();
                            break;
                        default:
                            break;
                    }
                }

                if (Instance.currentState ==='connected' && Instance.listeners['data']) {
                    Instance.listeners['data'](message, conn.peer);
                }
            });
        },

        on: (eventName, cb) => {
            Instance.listeners[eventName] = cb;

            if (eventName === 'connection') {
                if (Instance.currentLocalPeer) {
                    Instance.currentLocalPeer.on('connection', conn => {
                        console.log('connection', conn);
                        Instance.connection = conn;

                        Instance.onConnect(conn);
                    });
                }
            }

            return Instance;
        },

        peer: (id) => {
            // Instance.currentLocalPeer = Instance.localPeers[id];
            return Instance;
        },

        askToConnect: (id, userId) => {
            console.log('ask', Instance.currentLocalPeer, id)
            if (!Instance.currentLocalPeer) {
                return;
            }

            Instance.state('connecting');
            Instance.connect(id, DefaultPeerOptions);

            console.log('Connection here', Instance.connection)

            Instance.connection.on('open', () => {
                Instance.send({action: 'connect', userId});

                Instance.onConnect(Instance.connection);
            });

            Instance.initiatedByMe = true;

            return Instance;
        },

        accept: (userId) => {
            console.log('accept', Instance.currentLocalPeer, Instance.connection)
            if (!Instance.currentLocalPeer || !Instance.connection) {
                return;
            }

            Instance.send({action: 'confirm_handshake', userId});
            Instance.state('connected');

            return Instance;
        },

        refuse: (userId) => {
            Instance.state('ready');

            Instance.send({action: 'refuse_handshake', userId});

            return Instance;
        },

        send: (message) => {
            if (!Instance.currentLocalPeer || !Instance.connection) {
                return;
            }

            console.log('Send', message)
            Instance.connection.send(message);
        },

        connect: (id) => {
            if (!Instance.currentLocalPeer) {
                return;
            }

            Instance.connection = Instance.currentLocalPeer.connect(id);
            console.log('Connection', Instance.connection)

            return Instance;
        },

        register(list = []) {
            console.log('Register peers', list);
            list.forEach(id => {
                Instance.localPeers[id] = new PeerNode(id, DefaultPeerOptions);
                Instance.currentLocalPeer = Instance.localPeers[id];
            });
        },
    };

    return Instance;
};

window.Peer = Peer();

if (window.performance && window.performance.navigation && window.performance.navigation.type === performance.navigation.TYPE_RELOAD) {
    console.info( "This page is reloaded" );
    window.Peer.close();
}

const Queue = (self, onFailed = () => {}) => {
    self.interval = null;
    self.jobs = {};

    self.retries = 3;

    self.queue = (fn, name, param) => {
        self.jobs[name] = {fn, param, attempts: 0};

        if (!self.interval) {
            self.interval = setInterval(() => {
                const count = Object.keys(self.jobs).length;
                if (!count) {
                    clearInterval(self.interval);
                    self.interval = null;
                }

                Object.keys(self.jobs).forEach(name => {
                    const job = self.jobs[name];
                    self[job.fn](name, job.param);

                    // Not unqueued
                    if (self.jobs[name]) {
                        self.jobs[name].attempts++;

                        if (self.jobs[name].attempts > self.retries) {
                            self.unqueue(self.jobs[name]);
                            console.error(`Job unqueue: ${name}. Too many retries`);
                            onFailed();
                        }
                    }
                });

            }, 2000);
        }
    };

    self.unqueue = (name) => {
        delete self.jobs[name];
    };

    return self;
};

const PrivateChannel = ({name}) => {
    const ably = window.Echo.private(name);

    const self = {
        ably,

        name,
        listeners: {},
        whispers: {},

        loaded: () => {
            return window.AppEcho.loaded();
        },

        listen: (name, cb) => {
            if (!self.loaded()) {
                self.queue('listen', name, cb);
                return self;
            }

            if (self.listeners[name]) {
                return self;
            }

            self.listeners[name] = self.ably.listen(name, cb);

            self.unqueue(name);

            return self;
        },

        listenForWhisper: (name, cb) => {
            if (!self.loaded()) {
                self.queue('listenForWhisper', name, cb);
                return self;
            }

            if (self.whispers[name]) {
                return self;
            }

            self.whispers[name] = self.ably.listenForWhisper(name, cb);

            self.unqueue(name);

            return self;
        },

        whisper: (name, data) => {
            if (!self.loaded()) {
                self.queue('whisper', name, data);
                return self;
            }

            self.ably.whisper(name, data);

            self.unqueue(name);

            return self;
        },

        error: (cb) => {
            return self.ably.error(cb);
        },
    };

    return self;
};

window.Ably = Ably;
window.retries = 0;

const Bootstrap = () => {
    console.log('Bootstrap');

    window.retries++;
    if (window.retries > 3) {
        //
    }

    window.AppEcho = Queue({
        initialized: false,
        presence: false,
        state: '',

        channels: {},

        loaded: () => {
            return window.AppEcho.initialized && window.AppEcho.state === 'connected';
        },

        private: async (name) => new Promise(async (resolve) => {
            if (window.AppEcho.channels[name]) {
                resolve(window.AppEcho.channels[name]);
                return;
            }

            setTimeout(() => {
                window.AppEcho.channels[name] = Queue(PrivateChannel({name}));

                window.AppEcho.channels[name].error(error => {
                    console.error(`Channel: ${name}`, error);
                });

                resolve(window.AppEcho.channels[name]);
            }, 1000 + (1000 * Object.values(window.AppEcho.channels).length));
        }),

        join: (name, cb) => {
            if (!window.AppEcho.loaded()) {
                window.AppEcho.queue('join', name, cb);
                return window.AppEcho;
            }

            window.AppEcho.unqueue(name);

            return window.Echo.join(name)
                .here((users) => {
                    let list = [];
                    for (let arr of users) {
                        if (arr) {
                            list = [...list, ...arr.map(e => e.id)];
                        }
                    }

                    window.AppEcho.presence = true;
                    cb(list);
                })
                .joining((user) => {
                    //
                })
                .leaving((user) => {
                    //
                })
                .error((error) => {
                    console.error('presence.error', error);
                });
        },

        init: async (cb) => {
            window.Echo = new Echo({
                broadcaster: 'ably',
                authEndpoint: `${config.API_URL}/broadcasting/auth`,
                forceTLS: false,
                encrypted: true,
                withCredentials: true,
                enabledTransports: ['ws', 'wss'],
                auth: {
                    headers: {
                        'Authorization': `Bearer ${cookies.get('chat_api_token')}`,
                        'X-XSRF-TOKEN': cookies.get('XSRF-TOKEN'),
                    },
                },
            });
            window.AppEcho.initialized = true;

            window.Echo.connector.ably.connection.on(stateChange => {
                window.AppEcho.state = stateChange.current;

                console.log('Socket', stateChange.current, stateChange);
                if (window.AppEcho.state === 'connected') {
                    console.log('Connected to Socket server.');
                }

                if (window.AppEcho.state === 'suspended') {
                    //
                }

                if (window.AppEcho.state === 'failed') {
                    //
                }
            });

            cb && cb();
        },
    }, () => {
        Bootstrap();
    });

    window.AppEcho.init();
};

export default {
    init: Bootstrap,
};
